module.exports = __webpack_public_path__ + "img/legnano_venaria_hero_card.b94b12b3.png";